/**
 * Prefill transformer for 21P-534EZ.
 *
 * vets-api prefills the flat `your*` keys (see the form profile mappings:
 * yourName/yourDateOfBirth/yourSocialSecurityNumber from identity_information,
 * yourAddress/yourPhone/yourEmail from contact_information).
 *
 * When `survivorsBenefitsUpdatedPrefill` is on, the profile personal-info
 * page displays name/DOB from the Redux profile and no longer writes editable
 * `your*` fields, so these prefilled keys are the only source of claimant
 * name/DOB in the submit payload. Fall back to the Redux profile for name/DOB
 * when the prefill omits them so the submitted payload matches the legacy shape.
 *
 * The full prefill payload is spread through unchanged so the legacy
 * (feature-toggle-off) prefill behavior is preserved.
 *
 * @param {Object} pages - Form pages configuration passed through by the form system.
 * @param {Object} formData - Raw prefill data provided by vets-api.
 * @param {Object} metadata - Metadata object maintained by the form system.
 * @param {Object} state - Redux state, used to read the signed-in user's profile.
 * @returns {Object} Transformed pages, formData, and metadata.
 */
export default function prefillTransformer(pages, formData, metadata, state) {
  const { userFullName, dob } = state?.user?.profile || {};

  const yourName = formData?.yourName || userFullName;
  const yourDateOfBirth = formData?.yourDateOfBirth || dob;
  const pdfVersion = formData?.pdfVersion || '2025';

  return {
    pages,
    formData: {
      ...formData,
      ...(yourName ? { yourName } : {}),
      ...(yourDateOfBirth ? { yourDateOfBirth } : {}),
      pdfVersion,
    },
    metadata,
  };
}
